// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>72</span>&nbsp;&nbsp;So he shepherded them with a devoted heart&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and with skilful hands he guided them.<br> </p> </div></div>";
// Exports
module.exports = code;